import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, transition, style, animate, animateChild } from '@angular/animations';
@Component({
  selector: 'app-shortcut',
  templateUrl: './shortcut.component.html',
  styleUrls: ['./shortcut.component.scss'],
  animations: [
    trigger('listAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-100px)' }),
        animate('1000ms ease-out', style({ opacity: 1, transform: 'none' }))
      ])
    ])
  ]
})
export class ShortcutComponent implements OnInit {

  @Input() iconClass: String;
  @Input() textToShow: String;
  @Input() link: String;
  @Input() class: String;
  @Input() listAnimation;

  constructor(private router: Router) {
  }

  ngOnInit() {
  }

  redirect() {
    this.router.navigate([this.link]);
  }

}
